import { Box, Button, Card, CardContent, Grid, TextField, } from '@mui/material';
import { PageTitle } from 'components';
import { SaveIcon } from 'components/Layout/MainLayout/Sidebar/icons/SaveIcon';
import React from 'react';
import { useIntl } from "react-intl";
import { useDownloadPeopleCSVMutation } from 'redux/api/peopleOfinterestApi';
import styles from "scss/Page.module.scss";

const PeopleOfInterestDowloadCSV: React.FC = () => {
    const { formatMessage } = useIntl();  
    const [downloadCSV,{isLoading}] = useDownloadPeopleCSVMutation();

    const handleDownload = async () => {
      await downloadCSV()
    };
  
    
  
   
    return (
        <>
      <Grid container className={styles.viewContainer}>
        <PageTitle
          pageTitle={formatMessage({ id: "dowloadPeopleCSV.title" })}
        />
        <Card
        sx={{
          width: '100%'
        }}>
          <CardContent className={styles.cardContent}>
            <Box>
                
                <Box display="flex" gap={2} justifyContent="flex-start" mt={2}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleDownload}
                    startIcon={<SaveIcon />}
                    disabled={isLoading}
                    >
                    {formatMessage({ id: "dowloadPeopleCSV.button" })}
                  </Button>

                 
                </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
                    </>
    );
};

export default PeopleOfInterestDowloadCSV;